import { h, Component } from 'preact';
import { connect } from 'unistore/preact';
import {
  touchStart,
  touchEnd,
  handleSwipeCtrl,
  staticPath,
  updateSlideIndex
} from '../../utils/common';
import { onChange } from '../../common/actions';
import OverlayWrap from '../OverlayWrap';
import { CustomButtom } from '../btn';
import { locale } from '../../utils/i18n';

class Help extends Component {
  constructor(props) {
    super(props);
    this.swipeDist = 0;
    this.threshold = 10; // required min distance traveled to be considered swipe
    this.startX = 0;
    this.startY = 0;
    this.state = {
      currentSlide: 0,
      activeInd: 0,
      okBtn: false
    };
  }

  detectTouchStart(e) {
    const coord = touchStart(e);
    this.startX = coord.startX;
    this.startY = coord.startY;
  }

  detectTouchEnd(e, index) {
    const isrightswipe = touchEnd(e, this.startX, this.threshold);
    this.handleswipe(isrightswipe, index);
    e.preventDefault();
  }

  detectTouchMove(e) {
    e.preventDefault();
  }

  handleswipe(isrightswipe, index) {
    const res = handleSwipeCtrl(isrightswipe, index, this.props.helpText);
    this.setState({
      activeInd: res.actvInd,
      okBtn: res.okBtnVal,
      initialAnimation: true
    });
  }

  updateSlide(index) {
    this.setState(
      {
        activeInd: index,
        initialAnimation: true
      },
      () => {
        this.setState({
          okBtn: updateSlideIndex(this.state.activeInd, this.props.helpText.length)
        });
      }
    );
  }

  render(
    { title, closeHelp, helpImgTitle, helpText, headTitleLogo },
    { activeInd, initialAnimation, okBtn }
  ) {
    const dot = `ptm-help-dot`;
    const dotAct = `ptm-help-dot' ptm-btn-active`;
    const slideAct = `slide ptm-hidden`;
    const slide = `slide`;
    return (
      <OverlayWrap>
        <div className={`ptm-content-section`}>
          <div className={`ptm-content-top`}>
            <p className={`ptm-app-heading ptm-body-color`}>
              {title}
              {headTitleLogo && (
                <img
                  className={`paytm-logo`}
                  src={`${staticPath()}/assets/images/logo-paytm.svg`}
                  alt="paytm"
                />
              )}
              {helpImgTitle}
            </p>
            <div className={`ptm-close-wrap ptm-pos-a ptm-closeIcon`} onClick={e => closeHelp(e)}>
              <span className={`ptm-cross ptm-pos-r`} />
            </div>
            <div className={`ptm-sliderWrap paytm-txt-center`}>
              <ul className={`ptm-appWorkSlides`}>
                {helpText &&
                  helpText.length > 0 &&
                  helpText.map((data, index) => {
                    return (
                      <li
                        onTouchStart={e => this.detectTouchStart(e)}
                        onTouchMove={e => {
                          this.detectTouchMove(e);
                        }}
                        onTouchEnd={e => this.detectTouchEnd(e, index)}
                        className={`${index === activeInd ? slide : slideAct} ${
                          index
                            ? 'ptm-animated ptmslideInRight faster'
                            : initialAnimation
                            ? 'ptm-animated ptmslideInLeft faster'
                            : ''
                        }`}
                      >
                        <p className={`ptm-app-para ptm-body-color`}>{data.textSrc}</p>
                        <img src={data.imgSrc} alt="" className={`ptm-margin0 ptm-image`} />
                      </li>
                    );
                  })}
              </ul>
            </div>
            <div className={`ptm-btn-slider ptm-pos-a`}>
              {helpText &&
                helpText.length > 0 &&
                activeInd !== helpText.length - 1 &&
                helpText.map((data, index) => {
                  return (
                    <span
                      className={index === activeInd ? dotAct : dot}
                      onclick={() => this.updateSlide(index)}
                    />
                  );
                })}
              {okBtn && (
                <CustomButtom
                  btnText={locale('static.got.it')}
                  payEnabled={true}
                  onBtnClick={e => closeHelp(e)}
                  isAppInvoke={true}
                  className={`ptm-sliderBtn`}
                />
              )}
            </div>
          </div>
        </div>
      </OverlayWrap>
    );
  }
}

export default connect(
  '',
  onChange
)(Help);



// WEBPACK FOOTER //
// ./components/help/index.js